// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var invoiceRouter = {
  path: '/invoice',
  component: Layout,
  redirect: '/invoice/list',
  name: 'Invoice',
  meta: {
    title: '发票管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/invoice/list/index');
    },
    name: 'InvoiceList',
    meta: {
      title: '发票列表',
      icon: ''
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return import('@/views/invoice/detail/index');
    },
    name: 'InvoiceDetail',
    meta: {
      title: '发票详情',
      icon: ''
    },
    hidden: true
  }]
};
export default invoiceRouter;